import { Header } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import createArticleDraftData from "astrid-firestore/src/api/articles/createArticleDraftData";

import Button from "../../../ui/components/Buttons/Button";
import PlaceholderSegment from "../../../ui/components/PlaceholderSegment/PlaceholderSegment";
import ProductionCard from "../../../ui/components/ProductionCard/ProductionCard";

import Article from "../../../articles/components/Article/Article";
import ArticleEdit from "../../../articles/components/ArticleEdit/ArticleEdit";
import ArticlesDeliveryNeededMessage from "../../../articles/components/ArticlesDeliveryNeededMessage/ArticlesDeliveryNeededMessage";

import WorkSummary from "../../components/WorkSummary/WorkSummary";

export default function WorkOverviewView({ work, publisher, articles, artifacts, channels, productions }) {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const [articleDraft, setArticleDraft] = useState(null);

	return (
		<>
			<ArticlesDeliveryNeededMessage publisher={publisher} articles={articles} channels={channels} />

			<Header as="h3">{t("work", "Work")}</Header>

			<WorkSummary work={work} publisher={publisher} />

			<Header as="h3">{t("articles", "Articles")}</Header>

			{articles.map((article) => {
				return (
					<Article
						key={article.id}
						work={work}
						article={article}
						channels={channels}
						publisher={publisher}
						artifacts={artifacts?.filter((artifact) => artifact.article?.id === article.id)}
					/>
				);
			})}

			<PlaceholderSegment onClick={() => setArticleDraft(createArticleDraftData({ work, publisher }))}>
				<Button>{t("addArticle", "Add Article")}</Button>
			</PlaceholderSegment>

			<Header as="h3">{t("productions", "Productions")}</Header>

			{productions.map((production) => (
				<ProductionCard
					key={production.id}
					production={production}
					articles={articles}
					onClick={() => navigate(`/production/${production.id}`)}
				/>
			))}

			<PlaceholderSegment
				onClick={() => navigate(`/publisher/${work.publisher.id}/create-production?work=${work?.id}`)}
			>
				<Button>{t("createProduction", "Create production")}</Button>
			</PlaceholderSegment>

			{articleDraft && (
				<ArticleEdit
					onClose={() => setArticleDraft(null)}
					work={work}
					article={articleDraft}
					channels={channels}
					publisher={publisher}
				/>
			)}
		</>
	);
}
